import type { Address } from '@/modules/address/domain/Address';
import type { AddressRepository } from '@/modules/address/domain/AddressRepository';
import { sessionStorageRepository } from '@/modules/shared/infrastructure/SessionStorage';

const sessionStorageAddress = sessionStorageRepository<Address, number>(
  'addresses'
);

const getAll = (): Promise<Address[]> =>
  new Promise((resolve) => {
    setTimeout(async () => {
      resolve(await sessionStorageAddress.getAll());
    }, 1000);
  });

const save = (address: Address | Omit<Address, 'id'>): Promise<Address> =>
  new Promise((resolve) => {
    setTimeout(async () => {
      if ('id' in address) {
        resolve(await sessionStorageAddress.update(address));
      } else {
        resolve(await sessionStorageAddress.save(address));
      }
    }, 1000);
  });

const setDefaultAddress = (addressId: Address['id']): Promise<Address> =>
  new Promise((resolve, reject) => {
    setTimeout(async () => {
      const addresses = await sessionStorageAddress.getAll();
      if (addresses.find(({ id }) => id === addressId)) {
        const editedEntities = addresses.map((address) => ({
          ...address,
          isDefault: address.id === addressId
        }));
        await sessionStorageAddress.updateAllElements(editedEntities);
        resolve(editedEntities.find(({ id }) => id === addressId) as Address);
      } else reject(new Error(`Direccion con id ${addressId} no encontrada.`));
    }, 1000);
  });

export const addressSessionStorageRepository: AddressRepository = {
  getAll,
  save,
  setDefaultAddress
};
